// Resizes + compresses remote images through the wsrv.nl image CDN (WebP, long cache lifetime).
const IMAGE_CDN = 'https://wsrv.nl/'

export function optimizedImageUrl(url: string, width: number, quality = 72) {
  const clean = url.replace(/^https?:\/\//, '')
  return `${IMAGE_CDN}?url=${encodeURIComponent(clean)}&w=${width}&output=webp&q=${quality}&il`
}

export function optimizedSrcSet(url: string, widths: number[], quality?: number) {
  return widths.map((w) => `${optimizedImageUrl(url, w, quality)} ${w}w`).join(', ')
}
